(function () {
	'use strict';

	if (!customElements.get("custom-pickup-availability")) {
		customElements.define(
			"custom-pickup-availability",
			class CustomPickupAvailability extends HTMLElement {
				constructor() {
					super();

					if (!this.hasAttribute("available")) {
						return;
					}

					this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);

					this.onClickRefreshList = this.onClickRefreshList.bind(this);
					this.fetchAvailability = this.fetchAvailability.bind(this);

					this.initEventListeners();

					try {
						this.fetchAvailability(this.dataset.variantId);
					} catch (e) {}
				}

				initEventListeners() {
					document.addEventListener("theme:all:loaded", () => {
						this.fetchAvailability(this.dataset.variantId);
					});
				}

				fetchAvailability(variantId) {
					const sectionId = this.dataset.sectionId;
					let rootUrl = this.dataset.rootUrl;

					if (!rootUrl.endsWith("/")) {
						rootUrl = rootUrl + "/";
					}

					const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=custom-pickup-availability`;

					fetch(variantSectionUrl)
						.then((response) => response.text())
						.then((text) => {
							const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
							this.renderPreview(sectionInnerHTML, sectionId);
						})
						.catch(() => {
							const button = this.querySelector("button");

							if (button) {
								button.removeEventListener("click", this.onClickRefreshList);
							}

							this.renderError();
						});
				}

				onClickRefreshList() {
					this.fetchAvailability(this.dataset.variantId);
				}

				renderError() {
					this.innerHTML = "";
					this.appendChild(this.errorHtml);
					this.querySelector("button").addEventListener("click", this.onClickRefreshList);
				}

				renderPreview(sectionInnerHTML, sectionId) {
					const pickupAvailabilityPreview = sectionInnerHTML.querySelector("custom-pickup-availability-preview");

					if (!pickupAvailabilityPreview) {
						this.innerHTML = "";
						this.removeAttribute("available");
						return;
					}

					const toggle = pickupAvailabilityPreview.querySelector("[data-js-toggle-selector]");

					if (toggle) {
						toggle.dataset.target += `__${sectionId}`;
						toggle.dataset.jsToggle = toggle.dataset.target;
					}

					this.innerHTML = pickupAvailabilityPreview.outerHTML;
					this.setAttribute("available", "");

					const drawer = sectionInnerHTML.querySelector("custom-pickup-availability-drawer");

					if (drawer) {
						drawer.id += `__${sectionId}`;

						const toggle = drawer.querySelector("[data-js-toggle-selector]");

						if (toggle) {
							toggle.dataset.target += `__${sectionId}`;
							toggle.dataset.jsToggle = toggle.dataset.target;
						}

						const availableDrawer = document.querySelector(`custom-pickup-availability-drawer#customProductAvailability-${this.dataset.sectionId}`);

						if (availableDrawer) {
							availableDrawer.outerHTML = drawer.outerHTML;
						} else {
							document.body.appendChild(drawer);
						}
					}
				}
			}
		);
	}

	if (!customElements.get("custom-pickup-availability-drawer")) {
		customElements.define(
			"custom-pickup-availability-drawer",
			class CustomPickupAvailabilityDrawer extends HTMLElement {
				constructor() {
					super();
					window.themeCore.EventBus.emit(`custom-pickup-availability-drawer:${this.id}:loaded`);
				}
			}
		);
	}
})();